import { epic$, store } from '@redux/store';
import { totalDeliveryValueReducers } from 'features/totalDeliveryValue';
import { userProfileActions, userProfileReducers } from 'features/userProfile';
import { utmParametersActions } from 'features/utm';
import configurationSlice from './redux/configurationSlice';
import getConfigurationEpic from './redux/epics';
import uiStateSlice from './redux/uiStateSlice';

epic$.next(getConfigurationEpic);

store.dispatch(userProfileActions.fetch());
store.dispatch(utmParametersActions.fetch());
store.injectReducer('userProfile', userProfileReducers);
store.injectReducer('totalDeliveryValue', totalDeliveryValueReducers);
store.injectReducer('configuration', configurationSlice.reducer);
store.injectReducer('uiState', uiStateSlice.reducer);
store.dispatch(configurationSlice.actions.fetchConfiguration());
require('./components/modal');
require('./components/back');
require('./components/hamburgerMenu');
require('./components/dataLayer');
require('./components/responsiveLayoutHandler');
require('./redux/listeners');
